<template>
  <div id="csContainer" >
      <div class="getposition">

            <el-radio class="getposition2" v-model="radio" label="1">自由模式</el-radio>

            <br/>
          <el-radio  class="getposition2"v-model="radio" label="2">追踪模式</el-radio>

      </div>
  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'modelAnimation2',
        data(){
            return{
                radio:'1',
                viewer: null,
                drone : null,
                model: null
            }
        },
        watch:{
            radio:function (val) {
                if(val === '1'){
                    this.viewer.trackedEntity = null;
                    let viewer = this.viewer;
                    let initialPosition = new Cesium.Cartesian3.fromDegrees(-73.998114468289017509, 40.674512895646692812, 2631.082799425431);
                    let initialOrientation = new Cesium.HeadingPitchRoll.fromDegrees(7.1077496389876024807, -31.987223091598949054, 0.025883251314954971306);
                    let homeCameraView = {
                        destination : initialPosition,
                        orientation : {
                            heading : initialOrientation.heading,
                            pitch : initialOrientation.pitch,
                            roll : initialOrientation.roll
                        }
                    };
                    viewer.scene.camera.flyTo(homeCameraView);
                }else if(val === '2'){
                    // console.log('12');
                    this.viewer.trackedEntity = this.drone;
                }
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                this.viewer = util.getViewer("csContainer",{
                    // scene3DOnly: true,
                    baseLayerPicker: false,
                    shouldAnimate: true,
                    animation: true,
                    timeline: true,
                    // terrainProvider: Cesium.createWorldTerrain()
                });
                let viewer = this.viewer;
                let initialPosition = new Cesium.Cartesian3.fromDegrees(-73.998114468289017509, 40.674512895646692812, 2631.082799425431);
                let initialOrientation = new Cesium.HeadingPitchRoll.fromDegrees(7.1077496389876024807, -31.987223091598949054, 0.025883251314954971306);
                let homeCameraView = {
                    destination : initialPosition,
                    orientation : {
                        heading : initialOrientation.heading,
                        pitch : initialOrientation.pitch,
                        roll : initialOrientation.roll
                    }
                };
                viewer.scene.camera.setView(homeCameraView);

                let dronePromise = Cesium.CzmlDataSource.load('/demo/static/data/czml/sampleFlight.czml');

                let self = this;
                dronePromise.then(function (dataSource) {
                    viewer.dataSources.add(dataSource);
                    self.drone = dataSource.entities.getById('Aircraft/Aircraft1');
                    self.drone.model = {
                        uri : '/demo/static/data/models/people.glb',
                        scale:0.0001,
                        minimumPixelSize : 128,
                        // maximumScale : 1000,
                        silhouetteColor : Cesium.Color.WHITE,
                        silhouetteSize : 2,
                        // incrementallyLoadTextures: false
                    };


                    self.drone.orientation = new Cesium.VelocityOrientationProperty(self.drone.position);

                    // 光滑的路径插值
                    self.drone.position.setInterpolationOptions({
                        interpolationDegree : 3,
                        interpolationAlgorithm : Cesium.HermitePolynomialApproximation
                    });
                    self.drone.viewFrom = new Cesium.Cartesian3(-30, 0, 0);
                    // viewer.trackedEntity = drone;
                });

                let urlMaterialImg = "img/material/star.jpg";




            },


        }
    }
</script>
<style scoped>
    .getposition {
        position: absolute;
        margin-top: 7px;
        margin-left: 25px;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .getposition2{
        margin: 15px !important;
        color:white !important;
    }
  /*.free {*/
  /*  position: absolute;*/
  /*  margin-left: 50px;*/
  /*  margin-top:20px;*/
  /*  z-index: 999;*/
  /*}*/
  /*.track {*/
  /*    position: absolute;*/
  /*    margin-left: 50px;*/
  /*    margin-top:60px;*/
  /*    z-index: 999;*/
  /*}*/
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
